import { PrismicComplexBackgroundProps } from '../utilities/types';
import { isEmpty } from '../utilities/objects';
import * as React from 'react';
import { BrowseMasthead } from '../molecules/mastheads/BrowseMasthead';
import { rebrand } from '../../../theme/color';

export type PrismicBrowseMastheadPayload = PrismicComplexBackgroundProps & {
  primary: {
    heading?: string;
    subtitle?: string;
  };
};
export type PrismicBrowseMastheadProps = {
  payload: PrismicBrowseMastheadPayload;
};

const headingsWithSubtitles: Record<string, string> = {
  Browse: 'Categories, Themes, Playlists and more',
  'Featured Artists': "Discover some of the world's biggest artists on Lickd",
  Genres: 'Explore tracks, artists and playlists for each genre',
  'Video Themes': 'Curated selections for your video subject',
  'Top Hits': 'Only the biggest songs',
  'Moods & Vibes': 'Set the mood with music',
  'Included Playlists': 'Royalty-free music, unlimited usage with a subscription',
  'Premium Playlists': 'Mainstream music from big artists and labels, only licensable on Lickd',
  'Eras & Decades': 'Evoke nostalgia with songs throughout the years',
  Instrumentals: 'Ditch the vocals with these instrumental tracks',
  'Sound Effects & Stings': 'Make your videos more immersive with SFX',
  'New and Discovery': 'Discover fresh releases and new additions to Lickd',
  'Music Toolkit': 'Perfect tracks for specific uses and scenarios',
  'Artist Radio': "We might not have your favorite artist yet, but you'll probably like these",
};

export const PrismicBrowseMasthead: React.SFC<PrismicBrowseMastheadProps> = ({
  payload: {
    primary: {
      heading,
      subtitle,
      background_image,
      background_colour,
      background_gradient_colour_end,
      background_gradient_colour_direction,
    },
  },
}) => {
  return (
    <BrowseMasthead
      src={!isEmpty(background_image) && background_image.url}
      gradient={{
        from: background_colour,
        to: background_gradient_colour_end,
        direction: background_gradient_colour_direction,
      }}
      heading={heading}
    >
      {/* Show the subtitle if provided, otherwise fallback to the matching subtitle based on the heading */}
      {subtitle ? (
        <h2>{subtitle}</h2>
      ) : (
        heading &&
        headingsWithSubtitles[heading] && (
          <h2 style={{ color: rebrand.contrast[30].toString() }}>{headingsWithSubtitles[heading]}</h2>
        )
      )}
    </BrowseMasthead>
  );
};
